import { Injectable } from '@angular/core';
import { AssistantProposedTask } from './assistant-chat.service';

/**
 * Buzón de tareas confirmadas en el asistente, pendientes de aplicarse al cómputo.
 *
 * El chat vive en AppComponent y se usa desde cualquier pantalla, pero sólo
 * ComputeComponent sabe aplicar tareas. Sin este buzón, confirmar desde el
 * perfil disparaba un evento que nadie escuchaba y la tarea se perdía.
 *
 * El flujo es: el chat deja las tareas acá → navega a /computo → el cómputo
 * las consume cuando termina de cargar sus stages.
 */
@Injectable({
  providedIn: 'root'
})
export class AssistantPendingTasksService {
  private pending: AssistantProposedTask[] = [];

  /** Deja tareas a la espera de que el cómputo esté listo para aplicarlas. */
  set(tasks: AssistantProposedTask[]): void {
    this.pending = [...tasks];
  }

  hasPending(): boolean {
    return this.pending.length > 0;
  }

  /** Devuelve las tareas pendientes y vacía el buzón (se consumen una sola vez). */
  consume(): AssistantProposedTask[] {
    const tasks = this.pending;
    this.pending = [];
    return tasks;
  }

  clear(): void {
    this.pending = [];
  }
}
